'use client';

import { Direction, SortableTableHeaderCell, Table, TableHeaderRow } from '@pickleballinc/features/src/table';

import { TransactionsTableRow } from '@/components/molecules';
import { PlayerTransactionsData } from '@/entities';

interface TransactionsTableProps {
	playerTransactions: PlayerTransactionsData[];
}

export const TransactionsTable = ({ playerTransactions }: TransactionsTableProps) => {
	const headerCellStyle = 'px-3 py-3 sm:px-6 font-medium !text-gray-600 text-start text-nowrap !bg-brand-25';

	const onSort = (_columnName: string, _direction: Direction) => {};

	return (
		<div className="flex flex-col gap-4">
			<h2 className="text-2xl font-semibold leading-8 text-brand-700">Transactions</h2>

			<div className="h-auto max-w-[860px] rounded-lg bg-white shadow-md">
				<Table className="w-full table-auto">
					<thead>
						<TableHeaderRow className="h-11 items-start text-wrap bg-brand-25 text-xs font-light leading-[18px] text-gray-600">
							<SortableTableHeaderCell className={`${headerCellStyle} rounded-tl-lg`} columnName="Invoice" onSort={onSort}>
								<span>Invoice</span>
							</SortableTableHeaderCell>
							<SortableTableHeaderCell className={`${headerCellStyle}`} columnName="Date paid" onSort={onSort}>
								<span>Date paid</span>
							</SortableTableHeaderCell>
							<SortableTableHeaderCell className={`${headerCellStyle}`} columnName="Description" onSort={onSort}>
								<span>Description</span>
							</SortableTableHeaderCell>
							<SortableTableHeaderCell className={`${headerCellStyle}`} columnName="Payment method" onSort={onSort}>
								<span>Payment method</span>
							</SortableTableHeaderCell>
							<SortableTableHeaderCell className={`${headerCellStyle} rounded-tr-lg`} columnName="Amount" onSort={onSort}>
								<span>Amount</span>
							</SortableTableHeaderCell>
						</TableHeaderRow>
					</thead>
					<tbody>
						{playerTransactions.map((row, index) => (
							<TransactionsTableRow
								key={row.invoice}
								id={index}
								invoice={row.invoice}
								datePaid={row.datePaid}
								description={row.description}
								paymentMethod={row.paymentMethod}
								amount={row.amount}
								transactionsDataLength={playerTransactions!.length}
							/>
						))}
					</tbody>
				</Table>
			</div>
		</div>
	);
};
